module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ifa5g3/image/Front.jpg?1725276968017",
      "alt": "This image is the cover for the book The Bearmoose"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Bearmoose\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In a blizzard’s blinding fury, the Bearmoose finds herself alone, separated from her pride during their migration south. Her white fur, once a source of warmth and protection, now serves as a camouflage that isolates her in an unforgiving wilderness. As she embarks on a quest to reunite with her family, the Bearmoose faces a series of daunting challenges and encounters unfriendly foes at every turn. Will she succumb to despair and give up, or will her unwavering strength, courage, and indomitable spirit earn her the loyalty of some unlikely new companions? If she can forge these unexpected alliances, will they be enough to help her navigate the treacherous path back to her pride? Follow the Bearmoose on an unforgettable journey of resilience, friendship, and the power of never giving up.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      DM Kennedy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Aptos\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("DM Kennedy grew up in Northern England, where she developed a love for reading, writing and rhyming. She now lives in Philadelphia, Pennsylvania with her husband and two daughters.  ")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0